// import HamburgerSVG from '@/assets/icons/hamburger.svg?react'
import Logo from '@/assets/logo.svg?react'
import skleppng from '@/assets/sklep.png'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import Navigation from './components/Navigation'

function Header({ hideShopLogo = false }: { hideShopLogo?: boolean }) {
  const [isOpened, setIsOpened] = useState(false)

  // const handleClick = () => {
  //   setIsOpened((prev) => !prev)
  // }

  const handleClose = () => {
    setIsOpened(false)
  }

  const Navbar = () => (
    <div className={`absolute mx-auto w-full`}>
      <div className="mx-auto mt-4 flex max-w-3xl flex-row items-center justify-between rounded-xl bg-white px-6 py-3 shadow-form">
        {!hideShopLogo && (
          <img
            alt="sklep"
            className="absolute top-2 left-2 z-10 hidden h-[50px] object-cover lg:block xl:h-[81px]"
            src={skleppng}
          />
        )}
        <Link to="/">
          <Logo height={40} width={120} />
        </Link>

        {/* <div className="flex cursor-pointer md:hidden" onClick={handleClick}>
          {isOpened ? 'X' : <HamburgerSVG />}
        </div> */}

        <Navigation />
      </div>
    </div>
  )

  return (
    <>
      <Navbar />
      <div
        className={`fixed inset-x-0 top-[81px] bottom-0 z-20 bg-black/50 transition-all ${
          isOpened ? 'visible opacity-100' : 'invisible opacity-0'
        }`}
        id="sidebarfixed"
        onClick={handleClose}
      ></div>
    </>
  )
}

export default Header
